import { useState } from 'react';
import { Job } from '../@types/Jobs';

interface UseWarningsResult {
  isOpenWarningsModal: boolean;
  job: Job | undefined;
  openWarningsModal: (job: Job) => void;
  closeWarningsModal: () => void;
}

export const useWarnings = (): UseWarningsResult => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [job, setJob] = useState<Job | undefined>(undefined);

  const openWarningsModal = (job: Job) => {
    setJob(job);
    setIsOpen(true);
  };

  const closeWarningsModal = () => {
    setIsOpen(false);
    setJob(undefined);
  };

  return {
    isOpenWarningsModal: isOpen,
    job,
    openWarningsModal,
    closeWarningsModal
  };
};
